import { Link, useNavigate } from "react-router-dom";
import { Bell, ChevronRight, CreditCard, Gift, LogOut, Settings, Wallet } from "lucide-react";

import { useAuth } from "@/lib/auth";
import { Badge, Button, Card } from "@/components/kit";
import { C } from "@/lib/format";

export function MenuItem({ icon: Icon, label, sub, to, testID, right }) {
  return (
    <Link to={to} data-testid={testID} className="focus-ring flex min-h-[52px] items-center gap-3 rounded-xl px-2 py-3 transition-colors hover:bg-white/5">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#292415]">
        <Icon className="h-5 w-5 text-[#D4AF37]" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[15px] font-medium text-white">{label}</span>
        {sub ? <span className="t-caption block">{sub}</span> : null}
      </span>
      {right}
      <ChevronRight className="h-[18px] w-[18px] text-[#9E9E9E]" aria-hidden />
    </Link>
  );
}

export default function Profile() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div data-testid="agent-profile-screen" className="mx-auto flex w-full max-w-3xl flex-col gap-4 p-4 pb-8 md:p-8">
      <div className="flex items-center gap-4">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-[#D4AF37] bg-[#292415]">
          <span className="t-h1 !text-[#D4AF37]">
            {user.first_name[0]}
            {user.last_name[0]}
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="t-h2" data-testid="profile-name">{user.name}</h1>
          <p className="t-caption">{user.agency} · {user.city}</p>
          <p className="t-caption">{user.email}</p>
        </div>
      </div>
      <Card className="!p-2">
        <MenuItem testID="profile-referral-link" icon={Gift} label="Parrainage" sub={`Mon code : ${user.referral_code}`} to="/referral" />
        <MenuItem testID="profile-commissions-link" icon={Wallet} label="Mes commissions" sub="Gagné, en attente, payé" to="/commissions" />
        <MenuItem
          testID="profile-rib-link"
          icon={CreditCard}
          label="Informations bancaires (RIB)"
          to="/rib"
          right={<Badge testID="profile-rib-status" label={user.has_rib ? "RIB renseigné" : "RIB manquant"} color={user.has_rib ? C.success : C.warning} />}
        />
        <MenuItem testID="profile-notifications-link" icon={Bell} label="Notifications" to="/notifications" />
        <MenuItem testID="profile-account-link" icon={Settings} label="Mon compte" sub="Infos, e-mail, mot de passe, données" to="/account" />
      </Card>
      <Button testID="profile-logout-button" title="Se déconnecter" icon={LogOut} variant="secondary" onClick={async () => { await logout(); navigate("/welcome", { replace: true }); }} />
      <p className="t-caption text-center">Ma Maison Suivie 2.0 · contact@mamaisonsuivie.fr</p>
    </div>
  );
}
